import React, { useContext } from 'react';

import { AuthContext } from '../../contexts/auth.context';
import { FavoritesContext } from '../../contexts/favorites.context';

import PodcastImage from '../podcast-image/PodcastImage';
import Button from '../button/Button';

import {
  StyledMenu,
  NavItem,
  UserAndActions,
  FavLink,
  SignInLink,
  Text
} from './Menu.styles';

const Menu = ({ open, setOpen }) => {
  const { currentUser } = useContext(AuthContext);
  const { favorites } = useContext(FavoritesContext);

  const handleClick = () => {
    setOpen(false);
  };

  return (
    <StyledMenu open={open}>
      <UserAndActions />
      {currentUser ? (
        <>
          <NavItem
            to="/favorites"
            activeClassName="active-link"
            onClick={handleClick}
          >
            Favorites
          </NavItem>
          {favorites.map(({ id, thumbnail, title }) => {
            return (
              <FavLink
                key={id}
                to={`/podcast/` + id}
                onClick={() => setOpen(false)}
              >
                <PodcastImage url={thumbnail} alt="podcast" size="xs" />
                <h3>
                  {title.length > 16 ? title.slice(0, 16) + '...' : title}
                </h3>
              </FavLink>
            );
          })}
        </>
      ) : (
        <>
          <Text>
            Join now to save <span>your favorite</span> <span>podcasts</span>
          </Text>
          <Button to="/signup" type="link" onClick={() => setOpen(false)}>
            Sign Up
          </Button>
          <SignInLink to="/signin" onClick={() => setOpen(false)}>
            Already have an account?
          </SignInLink>
        </>
      )}
    </StyledMenu>
  );
};

export default Menu;
